import { render, staticRenderFns } from "./GoBankrupt.vue?vue&type=template&id=40844896&"
import script from "./GoBankrupt.vue?vue&type=script&lang=js&"
export * from "./GoBankrupt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports